<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Product Group" :required="true">
              <input
                @blur="$v.productGroup.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.productGroup.name.$error }"
                v-model="productGroup.name"
              />
              <div class="invalid-feedback" v-if="!$v.productGroup.name.required">
                Please enter group
              </div>
            </form-group>

          
            <form-group label="Order" :required="true">
              <b-form-spinbutton
                locale="en"
                v-model="productGroup.order"
                step="1"
                min="1"
                max="1000000"
              ></b-form-spinbutton>

              <div
                class="invalid-feedback"
                v-if="!$v.productGroup.order.required"
              >
                Please enter order
              </div>
            </form-group>

            <form-group label="Image">
              <image-upload @files-uploaded=" productGroup.image_id = $event;
              imageUploading = false; " @files-uploaded-started="imageUploading
              = true" :multiple="false" :imageCrop=true :imageCropRatio=1/1
              :validationState="imageVstate" acceptedTypes="image/*" />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import productGroupRepo from "@/api/repos/productGroupRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    productGroup: {
      name: {
        required,
      },
      order:{
        required
      }
    },
  },

  mounted() {},

  data() {
    return {
      productGroup: {
        order:100
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await productGroupRepo.create(this.productGroup);
          this.$emit("productGroupCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

